import { Injectable } from '@angular/core';
import { BuroSubeInfo } from '@core/models/genel/BuroSubeInfo';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SelectedSubeService {
    private subeSubject = new BehaviorSubject<BuroSubeInfo | null>(null);
	private selectedIdSource = new BehaviorSubject<number | null>(null);
 	selectedId$ = this.selectedIdSource.asObservable();
    sube$ = this.subeSubject.asObservable();

    // seçimi güncelle
    setSube(sube: BuroSubeInfo) {
        this.subeSubject.next(sube);
    }

    // mevcut seçimi almak istersen
    getSube(): BuroSubeInfo | null {
        return this.subeSubject.getValue();
    }

	setSelectedId(id: number) {
		this.selectedIdSource.next(id);
	}

	getSelectedId(): number | null {
		return this.selectedIdSource.value;
	}

    clearSube() {
        if (this.subeSubject.value) {
            this.subeSubject.next(null);
        }
        if (this.selectedIdSource.value) {
            this.selectedIdSource.next(null);
        }
    }
}
